jQuery(function($) {

    $('.programmes-filter .programmes-filter__form').submit(function(e) {
        e.preventDefault();

        let $this = $(this),
            datas = $this.serialize();

        $.ajax({
            url: kreenoot_child.ajax_url,
            method: "POST",
            data: datas,
            beforeSend: function() {
                $this.find('button').prop('disabled', true);
                $('.programmes-listing').addClass("is-loading");
            }
        }).success(function(response) {

            if(response.success) {
                $('.programmes-listing').empty();
                $('.programmes-listing').html(response.data);
                $('.programmes-listing').removeClass("is-loading");
            }

            let href = `?${datas}`;

            href = href.replace("action=program_filter&is_ajax=1&", "");
            href = href.replace("action=program_filter&is_ajax=1", "");

            history.pushState({}, document.title, href);

            $this.find('button').prop('disabled', false);
        });
    })

});